import React from 'react'
import {
  productsApi,
  ProductProvider,
  LocalLabelsProvider,
} from '@sentecacommerce-theme/lib'

import { ProductComponent } from './Components/ProductComponent'
import { ProductPlaceholder, ProductSEO } from './Components'

import { useRouter } from 'next/router'
import { ProductPageProps, ProductPageLabels } from './productPage.props'
import { ErrorPage } from '../ErrorPage'

export const ProductPage = ({
  tabs = [],
  labels,
  useCategoryCarousel,
  useProductsCarousel,
  notFound,
  SEO,
}: ProductPageProps) => {
  const router = useRouter()
  const slug = router.query.slug as string
  const { data, isFetching, isError } = productsApi.useProduct(slug, {
    expand: 'categories&brands',
  })

  if (isError) {
    return <ErrorPage {...notFound} />
  }

  if (isFetching || data?.slug[0]?.value !== slug) {
    return <ProductPlaceholder />
  }

  return (
    <LocalLabelsProvider<ProductPageLabels> labels={labels}>
      <ProductProvider
        product={data}
        defaultVariantId={data.masterVariantId || ''}
        query={{
          expand: 'categories&brands',
        }}
      >
        <ProductSEO
          favorTitleTemplateOverMeta={SEO.overrideTitleMetaWithTemplate}
          favorDescriptionTemplateOverMeta={
            SEO.overrideDescriptionMetaWithTemplate
          }
          titleTemplate={SEO.titleTemplate}
          descriptionTemplate={SEO.descriptionTemplate}
        />
        <ProductComponent
          key={slug}
          tabs={tabs}
          isCategoryCarouselActive={useCategoryCarousel}
          isProductsCarouselActive={useProductsCarousel}
        />
      </ProductProvider>
    </LocalLabelsProvider>
  )
}
